module.exports = __webpack_public_path__ + "static/media/sahil.cc1f20d6.png";